import ReactMarkdown from 'react-markdown';
import { remarkPlugins, rehypePlugins } from '../utils/markdown-config';
import styles from './ProactiveNudgeBody.module.css';

export interface ProactiveNudgeBodyProps {
  readonly summary: string;
}

/**
 * Renders a nudge's summary as markdown (so bold/lists/tables render rather
 * than showing literal markup). Purely presentational — opening the
 * conversation is handled by the surrounding card (see useNudgeOpen).
 */
export function ProactiveNudgeBody({ summary }: ProactiveNudgeBodyProps) {
  return (
    <div className={styles.markdown}>
      <ReactMarkdown
        remarkPlugins={remarkPlugins}
        rehypePlugins={rehypePlugins}
      >
        {summary}
      </ReactMarkdown>
    </div>
  );
}
